import request from './request'
const activity = 'ACTIVITY-SERVE'

// 活动计划列表
export function findList(data) {
  return request({
    url: activity + '/act-plan/findList',
    method: 'post',
    data
  })
}

// 活动计划详情
export function findById(data) {
  return request({
    url: activity + '/act-plan/findById?id=' + data,
    method: 'get'
  })
}

// 保存活动计划
export function saveActPlan(data) {
  return request({
    url: activity + '/act-plan/save',
    method: 'post',
    data
  })
}

// 保存活动计划
export function publishActPlan(data) {
  return request({
    url: activity + '/act-plan/publish',
    method: 'post',
    data
  })
}

// 保存活动计划
export function updateAfterPublish(data) {
  return request({
    url: activity + '/act-plan/updateAfterPublish',
    method: 'post',
    data
  })
}

// 删除活动计划
export function deleteActPlan(data) {
  return request({
    url: activity + '/act-plan/delete?id=' + data,
    method: 'get'
  })
}

// 导出活动计划
export function exportActPlan(data) {
  return request({
    url: activity + '/act-plan/export',
    method: 'post',
    responseType: 'blob',
    timeout: 600000,
    data
  })
}

// 导出活动计划
export function exportTipsDealer(data) {
  return request({
    url: activity + '/act-plan/exportTipsDealer',
    method: 'post',
    responseType: 'blob',
    timeout: 600000,
    data
  })
}

// 查询活动下发的经销商
export function findPlanDealers(data) {
  return request({
    url: activity + '/act-plan-dealer/findList',
    method: 'post',
    data
  })
}

// 保存活动下发的经销商
export function saveDealers(data) {
  return request({
    url: activity + '/act-plan-dealer/saveBatch',
    method: 'post',
    data
  })
}

// 保存活动下发的经销商,在查看页面使用
export function saveBatchInDetails(data) {
  return request({
    url: activity + '/act-plan-dealer/saveBatchInDetails',
    method: 'post',
    data
  })
}

// 删除活动下发的经销商
export function deleteDealers(data) {
  return request({
    url: activity + '/act-plan-dealer/delete',
    method: 'post',
    data
  })
}

// 获取该经销商能提报的所有活动
export function findActsByDealer(data) {
  return request({
    url: activity + '/act-plan-dealer/findActPlans',
    method: 'post',
    data
  })
}
// 导出该经销商能提报的所有活动
export function exportActsByDealer(data) {
  return request({
    url: activity + '/act-plan-dealer/export',
    method: 'post',
    responseType: 'blob',
    timeout: 600000,
    data
  })
}

// 获取该经销商15天内能提报的所有活动
export function findActPlanTips() {
  return request({
    url: activity + '/act-plan-dealer/findActPlanTips',
    method: 'get'
  })
}

// 活动下发经销商的信息，包括活动计划详细信息
export function findDealerActById(data) {
  return request({
    url: activity + '/act-plan-dealer/findById',
    method: 'post',
    data
  })
}

// 保存活动提报信息
export function saveApplyInfo(data) {
  return request({
    url: activity + '/act-plan-apply/save',
    method: 'post',
    data
  })
}

// 活动提报列表
export function findPlanApplyList(data) {
  return request({
    url: activity + '/act-plan-apply/findList',
    method: 'post',
    data
  })
}

export function approveApplyBatch(data) {
  return request({
    url: activity + '/act-plan-apply/approveApplyBatch',
    method: 'post',
    data
  })
}

export function approveApplyOffBatch(data) {
  return request({
    url: activity + '/act-plan-apply/approveApplyOffBatch',
    method: 'post',
    data
  })
}

export function approveApplyBatchInDb(data) {
  return request({
    url: activity + '/act-plan-apply/approveApplyBatchInDb',
    method: 'post',
    data
  })
}

// 导出活动提报列表（详细数据）
export function exportActPlanApply(data) {
  return request({
    url: activity + '/act-plan-apply/exportApplyList',
    method: 'post',
    responseType: 'blob',
    timeout: 600000,
    data
  })
}

// 导出活动提报列表(基础)
export function exportActPlanApply2(data) {
  return request({
    url: activity + '/act-plan-apply/exportApplyList2',
    method: 'post',
    responseType: 'blob',
    timeout: 600000,
    data
  })
}

// 活动提报详细
export function getActApplyDetail(data) {
  return request({
    url: activity + '/act-plan-apply/findById?id=' + data,
    method: 'get'
  })
}

// 删除提报活动
export function deleteActApply(data) {
  return request({
    url: activity + '/act-plan-apply/delete?id=' + data,
    method: 'get'
  })
}

// 保存活动提报集客信息
export function savePlanCustomers(data) {
  return request({
    url: activity + '/act-plan-customer/save',
    method: 'post',
    data
  })
}

// 活动提报集客信息列表
export function findPlanCustomers(data) {
  return request({
    url: activity + '/act-plan-customer/findList',
    method: 'post',
    data
  })
}

// 活动提报集客信息列表
export function getFileByte2(data) {
  return request({
    url: activity + '/act-plan-apply/getFileByte2?path=' + data,
    method: 'get'
  })
}



// 删除活动提报集客信息
export function deletePlanCustomers(data) {
  return request({
    url: activity + '/act-plan-customer/delete',
    method: 'post',
    data
  })
}

// 扫码集客信息列表
export function actCustomerfindList(data) {
    return request({
        url: activity + '/act-customer-info/findList',
        method: 'post',
        data
    })
}

// 核销集客信息列表
export function actCustomerListByActCode(data) {
    return request({
        url: activity + '/act-customer-info/actCustomerListByActCode',
        method: 'post',
        data
    })
}

// 获取文件
export function getFiles(data) {
  return request({
    url: activity + '/act-plan-apply/getFileByte',
    method: 'post',
    responseType: 'blob',
    timeout: 600000,
    data
  })
}

export function deleteFile(data) {
  return request({
    url: activity + '/act-plan-apply/deleteFile',
    method: 'post',
    data
  })
}

export function findFileInfo(data) {
  return request({
    url: activity + '/act-plan-apply/findFileInfo?code=' + data,
    method: 'get'
  })
}

export function getActApplyFileNum(data) {
  return request({
    url: activity + '/act-plan-apply/getActApplyFileNum?code=' + data,
    method: 'get'
  })
}

// 保存活动提报信息
export function saveWriteOffInfo(data) {
  return request({
    url: activity + '/act-plan-apply/saveWriteOff',
    method: 'post',
    data
  })
}

// 上传文件
export function uploadPlanFiles(data) {
  return request({
    url: activity + '/act-plan-apply/uploadFile',
    method: 'post',
    data,
    headers: {
      contentType: false,
      processData: false,
      dataType: 'json'
    }
  })
}

export function saveApproveInfo(data) {
  return request({
    url: activity + '/act-plan-apply/saveApproveInfo',
    method: 'post',
    data
  })
}

export function saveApplyOrderInfo(data) {
  return request({
    url: activity + '/apply-order/saveApproveInfo',
    method: 'post',
    data
  })
}

export function batchApproveExecuteInDb(data) {
  return request({
    url: activity + '/apply-order/batchApproveExecuteInDb',
    method: 'post',
    data
  })
}

export function updateOrderStatus(data) {
  return request({
    url: activity + '/apply-order/updateOrderStatus/' + data,
    method: 'get'
  })
}



export function relinquishWriteoff(data) {
  return request({
    url: activity + '/act-plan-apply/relinquishWriteoff',
    method: 'post',
    data
  })
}

// 导出活动执行核销列表
export function exportWriteOff(data) {
  return request({
    url: activity + '/act-plan-apply/exportWriteList',
    method: 'post',
    responseType: 'blob',
    timeout: 600000,
    data
  })
}

// 获取活动执行照片库
export function getCameraPictures(data) {
  return request({
    url: activity + '/act-plan-picture/findList',
    method: 'post',
    timeout: 600000,
    data
  })
}

// 获取文件
export function getPicByte(data) {
  return request({
    url: activity + '/act-plan-picture/getFileByte',
    method: 'post',
    responseType: 'blob',
    timeout: 600000,
    data
  })
}

// 选中执行图片
export function confirmPictures(data) {
  return request({
    url: activity + '/act-plan-picture/confirm',
    method: 'post',
    data
  })
}
// 通过编码获取归属分类来源分类
export function getClassByCode(data) {
  return request({
    url: activity + '/fiveLevelSource/getClassByCode?code=' + data,
    method: 'get'
  })
}

// 导入活动下发经销商
export function uploadPlanDealer(data) {
  return request({
    url: activity + '/act-plan-dealer/upload',
    method: 'post',
    data
  })
}

// 导入活动下发经销商
export function uploadPlanBatch(data) {
  return request({
    url: activity + '/act-plan-dealer/uploadPlanBatch',
    method: 'post',
    data
  })
}

// 导出经销商
export function exportDealer(data) {
  return request({
    url: activity + '/dealer/export',
    method: 'post',
    responseType: 'blob',
    timeout: 600000,
    data
  })
}

// 修改经销商关闭时间（活动已发布）
export function updateCloseTime(data) {
  return request({
    url: activity + '/act-plan-dealer/updateCloseTime',
    method: 'post',
    data
  })
}

// 批量修改经销商执行执行频率（查看界面中）
export function batchUpdateExecuteFreq(data) {
  return request({
    url: activity + '/act-plan-dealer/batchUpdateExecuteFreq',
    method: 'post',
    data
  })
}

// 删除活动下发经销商（活动已发布）
export function removePlanDealer(data) {
  return request({
    url: activity + '/act-plan-dealer/removePlanDealer?id=' + data,
    method: 'get'
  })
}

// 下载活动下发对象导入模板
export function exportActPlanTemp(data) {
  return request({
    url: activity + '/act-plan-dealer/exportActPlanTemp',
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 获取开票数 /act-plan-apply/carInvoiceCount ACTIVITY-SERVE
export function getCarInvoiceCount(data) {
  return request({
    url: activity + '/act-plan-apply/carInvoiceCount',
    method: 'post',
    data
  })
}
export function getPriceDiffApi(data) {
  return request({
    url: activity + '/act-plan-apply/getDealerApproveWriteoffCost',
    method: 'post',
    data
  })
}
